import { useIsUngated } from 'products-ui-components/hooks/useIsUngated';
import * as Gates from 'automation-ui-canvas/constants/Gates';
import { useSelector } from 'react-redux';
import { getIsEmbedded } from 'automation-ui-canvas/selectors/embedSelectors';
import { TestingMetaById } from 'automation-ui-canvas/components/panels/debugger-panel/constants/SingleActionTestingConstants';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
const useIsTestingEnabled = ({
  actionTypeId,
  flow
}) => {
  var _TestingMetaById$acti;
  const isObjectlessWorkflow = getIsObjectlessFlow(flow);
  const isUngatedForSingleActionTest = useIsUngated(Gates.SINGLE_ACTION_TEST);
  const isEmbedded = useSelector(getIsEmbedded);
  const isTestingEnabled = actionTypeId && ((_TestingMetaById$acti = TestingMetaById[actionTypeId]) === null || _TestingMetaById$acti === void 0 ? void 0 : _TestingMetaById$acti.isTestingEnabled);
  return isUngatedForSingleActionTest && !isEmbedded && isTestingEnabled && !isObjectlessWorkflow;
};
export default useIsTestingEnabled;